<template>
    <div class="common-layout">
        <div class="content">
            <div class="top">
                <div class="header">
                    <img alt="logo" class="logo" src="../assets/images/minitable-logo.png" />
                    <span class="title">{{ $t('sso.title') }}</span>
                </div>
                <div class="desc">Minitable Merchant</div>
            </div>
            <div class="panel">
                <a-spin :spinning="loading" :tip="status_text">
                    <div class="status-box">
                        <p>{{ status_text }}</p>
                        <a-button v-if="error" type="primary" @click="retry">{{ $t('sso.retry') }}</a-button>
                        <a-button v-if="error" style="margin-left: 8px;" @click="goLogin">{{ $t('sso.back_login') }}</a-button>
                    </div>
                </a-spin>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { applyEmbedFromQuery } from '../kits/embedMode';

export default {
    name: 'SsoCallbackPage',
    data() {
        return {
            loading: true,
            error: false,
            status_text: ''
        };
    },
    created() {
        this.syncEmbedMode();
        this.status_text = this.$t('sso.verifying');
        this.runVerify();
    },
    methods: {
        syncEmbedMode() {
            const enabled = applyEmbedFromQuery(this.$route.query);
            this.APP_SET_EMBED_MODE(enabled);
        },
        goLogin() {
            this.$router.replace({ path: '/login' });
        },
        retry() {
            this.error = false;
            this.loading = true;
            this.status_text = this.$t('sso.verifying');
            this.syncEmbedMode();
            this.runVerify();
        },
        async runVerify() {
            const token =
                (this.$route.query && this.$route.query.token) ||
                (this.$route.query && this.$route.query.sso_token) ||
                '';

            if (!token) {
                this.loading = false;
                this.error = true;
                this.status_text = this.$t('sso.missing_token');
                return;
            }

            try {
                const biz = await this.verify_sso_token({ token });
                if (biz.code === 100000) {
                    this.status_text = this.$t('sso.success');
                    const redirect =
                        (biz.data && biz.data.redirect_url) || '/waitlist';
                    this.$router.replace({ path: redirect });
                    return;
                }

                if (biz.code === 100001) {
                    this.status_text = this.$t('sso.need_register');
                    const redirect =
                        (biz.data && biz.data.redirect_url) || '/register';
                    // redirect_url 可能带 query，用完整 href 解析更稳
                    if (redirect.indexOf('?') > -1) {
                        const [path, qs] = redirect.split('?');
                        const query = {};
                        qs.split('&').forEach((pair) => {
                            const [k, v] = pair.split('=');
                            if (k) {
                                query[decodeURIComponent(k)] = decodeURIComponent(v || '');
                            }
                        });
                        this.$router.replace({ path, query });
                    } else {
                        this.$router.replace({
                            path: redirect,
                            query: {
                                tappo_id: (biz.data && biz.data.tappo_id) || '',
                                email: (biz.data && biz.data.email) || '',
                                merchant_name: (biz.data && biz.data.merchant_name) || '',
                                place_id: (biz.data && biz.data.place_id) || '',
                                phone: (biz.data && biz.data.phone) || ''
                            }
                        });
                    }
                    return;
                }

                this.loading = false;
                this.error = true;
                this.status_text = (biz && biz.msg) || this.$t('sso.verify_failed');
            } catch (e) {
                console.error(e);
                this.loading = false;
                this.error = true;
                this.status_text = this.$t('sso.verify_failed');
            }
        },
        ...mapActions({
            verify_sso_token: 'sso/verify_sso_token'
        }),
        ...mapMutations({
            APP_SET_EMBED_MODE: 'app/APP_SET_EMBED_MODE'
        })
    }
};
</script>

<style scoped>
.common-layout {
    display: flex;
    overflow: auto;
    flex-direction: column;
    height: 100vh;
}
.content {
    flex: 1;
    padding: 32px 0;
}
@media (min-width: 768px) {
    .content {
        padding: 112px 0 24px;
    }
}
.top {
    text-align: center;
}
.header {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 44px;
    line-height: 44px;
}
.logo {
    margin-right: 16px;
    height: 44px;
    vertical-align: top;
}
.title {
    position: relative;
    top: 2px;
    font-weight: 600;
    font-size: 28px;
}
.desc {
    margin-top: 12px;
    margin-bottom: 40px;
    font-size: 14px;
}
.panel {
    margin: 0 auto;
    width: 368px;
    text-align: center;
}
@media screen and (max-width: 576px) {
    .panel {
        width: 95%;
    }
}
.status-box {
    min-height: 120px;
    padding-top: 24px;
}
</style>
